var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256.000000 256.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
      "fill": _vm.primary,
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1175 2554 c-233 -38 -437 -175 -555 -372 -43 -73 -84 -181 -95 -252\n-4 -25 -15 -54 -25 -65 -33 -35 -40 -74 -40 -211 0 -148 10 -189 53 -217 15\n-10 30 -30 33 -45 11 -45 60 -147 95 -199 42 -62 144 -168 185 -194 18 -11 41\n-36 51 -56 21 -40 73 -73 114 -73 30 0 79 35 79 56 0 26 -28 70 -55 88 -14 9\n-46 18 -70 20 -87 5 -220 140 -295 298 -37 77 -37 92 -4 106 26 13 54 65 54\n104 0 13 15 -21 34 -74 81 -237 238 -418 414 -479 116 -40 261 -20 372 51 55\n35 152 135 199 203 42 62 99 185 121 262 l17 60 7 -39 c9 -49 29 -80 62 -94\n54 -25 120 -9 151 37 15 21 19 53 21 169 4 161 2 179 -31 219 -14 17 -29 54\n-36 93 -52 268 -272 504 -543 580 -72 21 -249 34 -313 24z m279 -94 c250 -64\n464 -289 502 -530 5 -32 4 -40 -9 -40 -9 0 -28 -11 -44 -24 l-28 -24 -12 62\nc-51 254 -287 426 -583 426 -296 0 -532 -172 -583 -427 l-12 -61 -43 37 -43\n36 11 50 c55 228 260 434 492 495 100 26 250 26 352 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M597 860 c-229 -109 -286 -146 -353 -228 -104 -128 -124 -197 -124\n-444 l0 -188 1160 0 1160 0 0 188 c0 126 -5 204 -14 238 -22 83 -76 173 -148\n246 -63 63 -81 75 -284 173 -119 58 -225 107 -235 108 -16 2 -42 -45 -140\n-248 -66 -137 -124 -253 -128 -258 -4 -4 -27 45 -50 110 -24 65 -52 141 -62\n168 l-19 50 -77 0 c-43 0 -81 -4 -85 -10 -3 -5 -34 -86 -69 -179 l-63 -170\n-60 125 c-34 68 -93 190 -132 271 l-70 147 -207 -99z"
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };